const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20female%20anime%20character%20avatar%20portrait%2C%20soft%20warm%20lighting%2C%20simple%20expression%2C%20pastel%20background%2C%20digital%20art&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '樱花落',
    time: '3小时前',
    text: '布丁漫画的下拉式阅读太方便了！躺在床上刷《秘密恋爱》根本停不下来，画风比别家清晰太多了，已经安利给闺蜜。',
    likes: '328',
    work: '正在追《秘密恋爱》',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20male%20anime%20character%20avatar%20portrait%2C%20soft%20warm%20lighting%2C%20simple%20expression%2C%20pastel%20background%2C%20digital%20art&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '夜雨声烦',
    time: '5小时前',
    text: '追《暗夜追凶》三个月了，每一话都在布丁漫画第一时间看到更新，翻译质量很高，剧情讨论区也很有氛围。',
    likes: '256',
    work: '正在追《暗夜追凶》',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20female%20anime%20character%20avatar%20portrait%2C%20soft%20warm%20lighting%2C%20gentle%20smile%2C%20pastel%20background%2C%20digital%20art&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '月下独酌',
    time: '昨天',
    text: '从别的平台转过来的，布丁漫画的收录真的全，好多完结韩漫全集都能直接看。恶役千金题材爱好者狂喜！',
    likes: '189',
    work: '正在追《恶役千金物语》',
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20male%20anime%20character%20avatar%20portrait%2C%20soft%20warm%20lighting%2C%20cool%20expression%2C%20pastel%20background%2C%20digital%20art&width=80&height=80&seq=avatar-04&orientation=squarish',
    name: '风起天阑',
    time: '2天前',
    text: '《剑与魔法》的更新速度全网最快没有之一，每天午休刷一话已经成为习惯了，感谢布丁漫画团队！',
    likes: '142',
    work: '正在追《剑与魔法》',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-[1080px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">读者评价</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            韩漫爱好者对布丁漫画的真实反馈，每一条都是我们前进的动力
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {comments.map((c, i) => (
            <div
              key={i}
              className="p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70"
            >
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img src={c.avatar} alt={c.name} className="w-full h-full object-cover" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-sm font-semibold text-foreground-950 whitespace-nowrap">{c.name}</span>
                    <span className="text-xs text-foreground-400">{c.time}</span>
                  </div>
                  <p className="mt-2 text-sm text-foreground-700 leading-relaxed">{c.text}</p>
                  <div className="mt-3 flex items-center gap-3 flex-wrap">
                    <span className="inline-flex items-center gap-1 text-xs text-foreground-400">
                      <i className="ri-heart-line text-secondary-500"></i>
                      {c.likes}
                    </span>
                    <span className="text-xs text-foreground-400 bg-secondary-50 px-2 py-0.5 rounded-full whitespace-nowrap">
                      {c.work}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}